import React, { Component } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Header,
  Form,
  Grid,
  Menu,
  Segment,
  Message,
} from "semantic-ui-react";
import * as ROUTES from "../../routes";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { AutoSizer } from "react-virtualized";
import authenticate from "../../authenticate";

class SignInView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      savedPassword: "",
    };

    this.AuthenticationService = authenticate(
      this.props.services.feathers,
      this.props.dispatch
    );
  }

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path)),
    };
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS(),
    };
  }

  componentDidMount() {
    const roles =
      this.props.authentication &&
      this.props.authentication.user &&
      this.props.authentication.user.roles
        ? this.props.authentication.user.roles
        : [];

    if (
      this.props.authentication &&
      this.props.authentication.user &&
      this.props.authentication.user.id
    ) {
      if (roles.indexOf("sysadmin") === -1) {
        if (!!this.props.authentication.user.needsReset) {
          this.props.navigate(
            `${ROUTES.CHANGE_PASSWORD}/${this.state.password}`
          );
          return;
        }
        this.props.navigate(ROUTES.DASHBOARD);
      } else {
        this.props.navigate(ROUTES.ADMIN);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const roles =
      this.props.authentication &&
      this.props.authentication.user &&
      this.props.authentication.user.roles
        ? this.props.authentication.user.roles
        : [];

    if (
      this.props.authentication &&
      this.props.authentication.user &&
      this.props.authentication.user.id
    ) {
      if (roles.indexOf("sysadmin") === -1) {
        if (!!this.props.authentication.user.needsReset) {
          this.props.navigate(
            `${ROUTES.CHANGE_PASSWORD}/${this.state.savedPassword}`
          );
          return;
        }
        this.props.navigate(ROUTES.DASHBOARD);
      } else {
        this.props.navigate(ROUTES.ADMIN);
      }
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  onSubmit = () => {
    const { username, password } = this.state;
    this.setState({
      savedPassword: password,
    });
    this.AuthenticationService({
      strategy: "local",
      username,
      password,
    });
  };

  render() {
    const { t, authentication } = this.props;
    const { error, loading } = authentication;

    return (
      <AutoSizer disableHeight style={{ display: "flex", flex: 1 }}>
        {({ width }) => {
          let Wrapper = Container;
          let style = {};

          if (width < 764) {
            Wrapper = "div";
            style = {
              margin: 0,
              width,
            };
          }

          return (
            <Wrapper style={style}>
              <Menu
                inverted
                style={{
                  backgroundColor: "#136444",
                  borderRadius: 0,
                  margin: 0,
                }}
              >
                <Menu.Item name="inicio" active={true} />
                <Menu.Item name="nosotros" active={false} />
              </Menu>

              <Segment vertical secondary style={{ padding: 4 }}>
                <Breadcrumb>
                  <Breadcrumb.Section as={Link} link to={"/"}>
                    Inicio
                  </Breadcrumb.Section>
                  <Breadcrumb.Divider icon="right angle" />
                  <Breadcrumb.Section active>Ingreso</Breadcrumb.Section>
                </Breadcrumb>
              </Segment>

              <Segment vertical>
                <Header as="h3">
                  <Header.Content>
                    INGRESAR
                    <Header.Subheader>Acceso al sistema</Header.Subheader>
                  </Header.Content>
                </Header>
              </Segment>

              <Segment vertical>
                <Grid container columns={3} centered stackable>
                  <Grid.Column>
                    <Segment clearing color="blue">
                      <Form
                        onSubmit={this.onSubmit}
                        error={!!error}
                        loading={loading}
                      >
                        <Message
                          error
                          header={!!error && error.name}
                          content={!!error && error.message}
                        />
                        <Form.Input
                          label="Usuario"
                          name="username"
                          onChange={this.handleChange}
                        />
                        <Form.Input
                          label="Clave"
                          name="password"
                          type="password"
                          onChange={this.handleChange}
                        />
                        <Button
                          content="Enviar"
                          icon="send"
                          type="submit"
                          floated="right"
                          primary
                        />
                      </Form>
                    </Segment>
                    <Button
                      as={Link}
                      to={ROUTES.RECOVERY}
                      content="Recuperar contraseña"
                      icon="help circle"
                      negative
                      fluid
                      primary
                    />
                  </Grid.Column>
                </Grid>
              </Segment>
            </Wrapper>
          );
        }}
      </AutoSizer>
    );
  }
}

const i18nEnhancement = translate("translations")(SignInView);
export default connect(
  SignInView.mapStateToProps,
  SignInView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/SignInView.jsx